<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

    <div id="page-administrator-list" class="ag-grid-container">
      <div class="vx-card">
        <grid-action-bar
            v-on:update:search="searchQuery = $event"
            v-on:update:deleted="showDeleted = $event"
            title="Administrators"
            :showDeleted="false"
        >
          <vs-dropdown-item v-if="componentAccess.canCreate.access">
            <span
                class="flex items-center"
                @click="$router.push({ name: 'content-management.administrators.create' })"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
              <span>Create Administrator</span>
            </span>
          </vs-dropdown-item>
        </grid-action-bar>
  
        <!-- AgGrid Table -->
        <t-grid
        v-if="!loading"
            :column-defs="columnDefs"
            class="lg"
            :data="data"
            :loading="loading"
            :search="searchQuery"
            :gridOptions="gridOptions"
            @rowClicked="rowClicked"
            @update:gridApi="(gridApi) => this.gridApi = gridApi"
            :autoGroupColumnDef="autoGroupColumnDef"
            autoSize
        >
        </t-grid>
  
      </div>
    </div>
  
  </template>
  
  <script>
  import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
  import vSelect from 'vue-select'
  import TGrid from "@/views/components/ag-grid/TGrid";
  import GridActionBar from "@/views/components/extra-components/GridActionBar";
  import CanAccessMixin from "@/components/mixins/CanAccessMixin";
  
  export default {
    components: {
      vSelect,
      TGrid,
      GridActionBar,
    },
    mixins: [CanAccessMixin],
    data () {
      return {
        searchQuery: '',
        showDeleted: false,
  
        componentAccess: {
          canCreate: {
            route: 'content-management.administrators.create',
            access: false,
          },
          canEdit: {
            route: 'content-management.administrators.edit',
            access: false,
          },
        },
        loading: false,
        data: [],
        autoGroupColumnDef: {
          headerName: 'Full Name',
          minWidth: 325,
        },
        gridApi: null,
        gridOptions: {},
        columnDefs: [
          {
            headerName: '',
            field: 'Contact_FK',
            filter: 'agTextColumnFilter',
            hide: true,
          },
          {
            headerName: 'Full Name',
            field: 'users.Name',
            filter: 'agTextColumnFilter',
            sort: 'asc',
            rowGroup: true,
            hide: true,
          },
          {
            headerName: 'Application',
            field: 'applications.ApplicationName',
            filter: 'agTextColumnFilter',
            minWidth: 200,
          },
        ],
      }
    },
    watch: {
      showDeleted(value) {
        this.list({IsDeleted: value | 0});
      }
    },
    computed: {},
    methods: {
      modalError(errorMessage) {
        this.$vs.notify({
          color: 'danger',
          title: 'Error occurred',
          text: errorMessage,
          position: 'top-right'
        })
      },
      success(successMessage) {
        this.$vs.notify({
          color: 'success',
          title: 'Contacts updated',
          text: successMessage,
          position: 'top-right'
        })
      },
      rowClicked(data) {
        let userId = null;

        if (data.data) {
          userId = data.data.Contact_FK;
        } else {
          userId = data.node.allLeafChildren[0].data.Contact_FK;
        }

        if (!userId) {
          return;
        }

        this.$root.$router.push({ path: `/content-management/administrators/${userId}` })
      },
      async list(params = {}) {
        try {
          const { data } = await this.$api.contentManagementAdministrators.all({ params });
          this.data = data.data;
          this.gridApi.paginationGoToFirstPage();
        } catch (e) {
          console.log(e);
        }
      },
      loadList () {
        this.list({IsDeleted: 0});
      },
    },
    async created () {
      this.loading = true;
      await this.loadList();

      this.loading = false;
    }
  }
  </script>
  
  <style lang="scss">
  #page-administrator-list {
    .administrator-list-filters {
      .vs__actions {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-58%);
      }
    }
  }
  </style>
  
